import { useQuery } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import { useCustomerValue } from "providers/CustomerContext";
import { useState } from "react";
import { getUserOptions } from "services/data.internal.service";
import BasicTabs from "ui-components/tabs/BasicTabs";
import InboundBillingReportConfiguration from "./inbound-billing-report-configuration";
import StorageBillingReportConfiguration from "./storage-billing-report-configuration";
import OutboundB2BBillingReportConfiguration from "./outbound-b2b-billing-report-configuration";
import OutboundB2CBillingReportConfiguration from "./outbound-b2c-billing-report-configuration";
import ReturnBillingReportConfiguration from "./return-billing-report-configuration";
import StuffingUnstuffingBillingReportConfiguration from "./stuffing-unstuffing-billing-report-configuration";
import VASBillingReportConfiguration from "./vas-billing-report-configuration";
import OTBillingReportConfiguration from "./ot-billing-report-configuration";
import ManagementFeesBillingReportConfiguration from "./managementfees-billing-report-configuration";
// import Pickslip from "./pickslip";
// import PickslipLocation from "./pickslip-location";
// import AllocationQueue from "./allocation-queue";
import { Checkbox } from "@mui/material";
import { ListLayout } from "ui-components/Layout";
// import Demo2 from "./demo2";
import SOLog from "layouts/views/outbound/sales-order/components/SOLog";
import { MessageDialog } from "ui-components/Alert";
import { CheckboxHeader, CheckboxCell } from "ui-components/tables/components/table";
import React, { useRef } from "react";
import { useTeamValue } from "providers/TeamContext";
import PackagingMaterialBillingReportConfiguration from "./packaging-material-billing-report-configutation";


const tabs = [
  "Storage",
  "Inbound",
  "Outbound (B2B)",
  "Outbound (B2C)",
  "Return",
  "Stuffing & Unstuffing",
  "Packaging Material",
  "VAS",
  "Management Fees",
  "OT",
];

function AddNewBillingList() {
  const {permissions, allowAll} = useTeamValue();
  const viewPricePermission =
    (Boolean(permissions["Team Role"]) && permissions["Team Role"].some(a => a === "access")) ||
     (Boolean(permissions["Billing Setup"]) &&
      permissions["Billing Setup"].findIndex((b) => b === "viewPrice") !== -1);

  const [status, setStatus] = useState("Storage");
  const { customerCode } = useCustomerValue();

const [isEdited, setIsEdited] = useState(false); // Tracks unsaved changes
const [dialog, setDialog] = useState(null);
const handleSaveRef = useRef(null); 
const handleTabChange = (newStatus) => {
  console.log('handletabchange');
  console.log('newstatusbeforegointoedited',newStatus);
  if (isEdited) {
    console.log('isedited');
    setDialog(
      <MessageDialog
        title="You have unsaved changes. Do you want to save before exiting?"
        onCancel={() => setDialog(null)}
        onOk={async () => {
          if (handleSaveRef.current) {
            console.log("Calling child's save function...");
            await handleSaveRef.current(); // Call handleSubmit from child
          }
          setIsEdited(false); // Reset flag
          setStatus(newStatus); // Switch tab
          setDialog(null);
        }}
        onClose={() => {
          setIsEdited(false); // Discard changes
          setStatus(newStatus); // Switch tab
          console.log('gt go into cancel changes and switch tab',newStatus);
          setDialog(null);
        }}
      />
    );
  } else {
    setStatus(newStatus);
  }
};

  const [userOptions, setUserOptions] = useState([]);
  const [szOptions, setSZOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [salesOptions, setSalesOptions] = useState([]);
  const [billingname, setBillingname] = useState("");

  const [list, setList] = useState([]);
  const [alert, setAlert] = useState(null);

  const [logRequest, setLogRequest] = useState(null);
  const [open, setOpen] = useState(false);
  const logProp = { open, setOpen, logRequest, setLogRequest };

  const columns = [
    {
      id: "select",
      cell: CheckboxCell,
    },
    {
      accessorKey: "orderDate",
      header: "Order Date",
      width: 150,
    },
    {
      accessorKey: "custOrdNbr",
      header: "Cust Order Number",
      width: 150,
    },
    {
      accessorKey: "referenceNo",
      header: "Reference No",
      width: 150,
    },
    {
      accessorKey: "category",
      header: "Category",
      width: 200,
    },
    {
      accessorKey: "marketplace",
      header: "Marketplace",
      width: 100,
    },
    {
      accessorKey: "shippingZone",
      header: "Shipping Zone",
      width: 150,
    },
    {
      accessorKey: "group",
      header: "Group",
      width: 60,
    },
    {
      accessorKey: "orderNumber",
      header: "Order Number",
      width: 150,
      cell: ({ row }) => {
        const { orderNumber } = row.original;
        return (
          <span
            style={{
              color: "#1A73E8",
              fontWeight: 400,
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => {
              setOpen(true);
              setLogRequest({ orderNumber, customerCode });
            }}
          >
            {orderNumber}
          </span>
        );
      },
    },
    {
      accessorKey: "remark",
      header: "Remark",
    },
  ];

  useQuery({
    queryKey: ["user-options"],
    queryFn: () => getUserOptions(),
    onSuccess: (data) => setUserOptions(data.data.data),
  });

  const render = () => {
    let task;
    switch (status) {
      case "Storage":
        task = (
          <StorageBillingReportConfiguration
            columns={columns}
            customerCode={customerCode}
            userOptions={userOptions}
            szOptions={szOptions}
            categoryOptions={categoryOptions}
            salesOptions={salesOptions}
            list={list}
            setList={setList}
            setAlert={setAlert}
            activeTab={"Storage"}
            billingname={billingname} // Pass as prop
            setBillingname={setBillingname} // Allow child to update
            isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
          />
        );
        break;

      case "Inbound":
        task = <InboundBillingReportConfiguration  columns={columns}
        customerCode={customerCode}
        userOptions={userOptions}
        szOptions={szOptions}
        categoryOptions={categoryOptions}
        salesOptions={salesOptions}
        list={list}
        setList={setList}
        setAlert={setAlert}
        activeTab={"Inbound"}
        billingname={billingname} // Pass as prop
            setBillingname={setBillingname} // Allow child to update
            isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
        />;
        break;

      case "Outbound (B2B)":
        task = <OutboundB2BBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"Outbound (B2B)"}
        billingname={billingname} // Pass as prop
        setBillingname={setBillingname} // Allow child to update
        isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
        />;
        break;

      case "Outbound (B2C)":
        task = <OutboundB2CBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"Outbound (B2C)"}
        billingname={billingname} // Pass as prop
        setBillingname={setBillingname} // Allow child to update
        isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
        />;
        break;

      case "Return":
        task = <ReturnBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"Return"}
        billingname={billingname} // Pass as prop
        setBillingname={setBillingname} // Allow child to update
        isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
        />;
        break;

      case "Packaging Material":
      task = <PackagingMaterialBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"PackagingMaterial"}
      billingname={billingname} // Pass as prop
      setBillingname={setBillingname} // Allow child to update
      isEdited={isEdited}
          setIsEdited={setIsEdited}
          onSubmit={(handleSubmit) => {
            handleSaveRef.current = handleSubmit; // Store reference to child's function
          }}
          viewPricePermission={viewPricePermission}
      />;
      break;

      case "Stuffing & Unstuffing":
        task = <StuffingUnstuffingBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"StuffingUnstuffing"}
        billingname={billingname} // Pass as prop
        setBillingname={setBillingname} // Allow child to update
        isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
        />;
        break;

      case "VAS":
        task = <VASBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"VAS"}
        billingname={billingname} // Pass as prop
        setBillingname={setBillingname} // Allow child to update
        isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
        />;
        break;

      case "Management Fees":
        task = <ManagementFeesBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"ManagementFees"}
        billingname={billingname} // Pass as prop
        setBillingname={setBillingname} // Allow child to update
        isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
        />;
        break;

      case "OT":
        task = <OTBillingReportConfiguration customerCode={customerCode} setAlert={setAlert} activeTab={"OT"}
        billingname={billingname} // Pass as prop
        setBillingname={setBillingname} // Allow child to update
        isEdited={isEdited}
            setIsEdited={setIsEdited}
            onSubmit={(handleSubmit) => {
              handleSaveRef.current = handleSubmit; // Store reference to child's function
            }}
            viewPricePermission={viewPricePermission}
        />;
        break;
    }

    return task;
  };
  return (
    <ListLayout lg={12}>
      <SOLog {...logProp} />
      {dialog}
      <MDBox my={3}>
        {alert}
        <BasicTabs tabs={tabs} status={status} setStatus={handleTabChange} />

        <MDBox>{render()}</MDBox>
      </MDBox>
    </ListLayout>
  );
}

export default AddNewBillingList;
